import { Component } from '@angular/core';
import { StateService } from '../../services/state.service';
import { ClaimsService } from '../../services/claims.service'; 
import { Router } from '@angular/router';

interface SectionData {
  id: number;
  title: string;
  description: string;
  checked: boolean;
  completed: boolean;
  visible: boolean;
  agreementAccepted: boolean; 
  declineDescription: string;
  consentDescription: string;
  userData?: any;
}

@Component({
    selector: 'app-scripting',
    standalone: true,
    templateUrl: './scripting.component.html',
    styleUrl: './scripting.component.css'
})
export class ScriptingComponent { 

  constructor(protected stateService: StateService, protected claimsService: ClaimsService,  private router: Router,) {}

  sections: SectionData[] = [];

  introducerIdAA = 2;
  isIntroducerAA: boolean = false;
  hasMLP: boolean = false;
  isRehabNeeded: boolean = false;
  rehabTeam : string = '';

  ngOnInit(): void {    

    this.isIntroducerAA = this.stateService.claim!.introducerId == this.introducerIdAA;
    this.hasMLP = this.stateService.claim!.claimFunding!.hasMlp;
    this.isRehabNeeded = this.stateService.claim!.injury.isRehabNeeded;

    this.rehabTeam = this.stateService.getLooUpValue('Introducer', this.introducerIdAA);
    this.sections = [
        { 
        id: 1, 
        title: 'Statement of Truth', 
        description: `<p>I confirm that all the information I have provided is true. 
                      I understand that if any of the information I have provided is untrue or exaggerated, the whole or part of my claim and any claims connected to it may be dismissed. 
                      I understand that I may be ordered to pay the other side's legal costs and be found in contempt of court if it's found I made a false statement.</p>`,
        checked: false,
        completed: false,
        visible: true,
        agreementAccepted: false,
        declineDescription: `We cannot proeceed without your confirmation that all the informatin you have provded is true.`,
        consentDescription: `I accept`,
        userData: { type: 'Statement of Truth', version: 'Statement of Truth' }
        },
        { 
        id: 2, 
        title: 'Funding', 
        description:  this.isIntroducerAA && this.hasMLP ? 
                      `<h4>MLP CCFA</h4>
                      <p>Your claim will be funded by a Collective Conditional Fee Agreement (or CCFA).</p> 
                      <p>As you already have legal expense insurance with your insurer, if your claim is successful, you’ll receive 100% of your compensation.</p>
                      <p>If your claim is unsuccessful there will be nothing for you to pay. </p>
                      <p>However, this is only if you comply with both our and your insurers terms and conditions.</p>
                      <p>You have the right to cancel within 14 days without giving any reason and without incurring any liability for our costs. </p>
                      <p>Further details about how your claim is funded and cancelling your claim will be in your welcome pack.</p> ` : 
                        `<h4>No MLP 25%</h4>
                      <p>Your claim will be funded by a Conditional Fee Agreement (or CFA).</p>
                      <p>If your claim is successful, our normal fees and a success fee will apply. These costs will be capped at 25% of your compensation. Ensuring that if you win, at least 75% of your compensation is protected and payable to you.</p>
                      <p>If your claim is unsuccessful, there'll be nothing for you to pay.</p>
                      <p>However, this is only if you comply with our terms and conditions.</p>
                      <p>Your insurer has indicated you do not have legal expenses cover. If you have legal expenses insurance or trades union legal assistance, we will generally not charge you for our costs, and you'll receive 100% of your compensation. If you do have either of these, please let us know and provide any supporting evidence.</p>
                      <p>If you have home insurance with LV/Allianz then you should check your policy as it may cover you for this claim. </p>
                      <p>Further details about funding your claim, trade union cover, and legal expenses insurance will be in your welcome pack and CFA. You've the right to cancel within 14 days without giving any reason and without incurring liability for our costs.</p>`,  
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: `We cannot proceed without your agreement to how your claim is funded. To speak to a member of our team in more details please contact 01904 663089.`,
        consentDescription: `I'm happy to proceed under this funding agreement.`,
        userData: { type: 'Funding', scope: 'Funding' }
        },
        { 
        id: 3, 
        title: 'Confirmation', 
        description: `I confirm that I am happy for Minster Law to now proceed with a personal injury claim on my behalf.`,
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: `We cannot proceed without your consent.`,
        consentDescription: `I accept`,
        userData: { type: 'Happy To Proceed', scope: 'Happy To Proceed' }
        },
        { 
        id: 4, 
        title: 'ASKCUE', 
        description: `<p>To proceed, we need to complete a check on your previous claims' history. This is a required standard search completed by all solicitors, insurers and claims companies as part of making a claim.
                      Your information will be shared with relevant parties like the insurance fraud bureau. This is for anti-fraud purposes and ensures we're compliant with our legal obligations.</p>
                     <p>*This is a required search needed to progress a personal injury claim and will be conducted by all solicitors and claims companies to check for high levels of injury claims being made. 
                     Without your consent, we cannot proceed.</p>`,
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: `We cannot proceed without your consent.`,
        consentDescription: `I consent to check my claims history`,
        userData: { type: 'AskCue', scope: 'AskCue' }
        },
        { 
        id: 5, 
        title: this.isRehabNeeded ? 'Rehab' : 'No rehab', 
        description: this.isRehabNeeded ? 
                      `<p>We can arrange for assessment and treatment to support your recovery. This will be included in your claim, and the rehab agency will be paid directly after recovering the costs from the third-party insurers. As long as you comply with the terms and conditions covered in your insurance policy, the rehab provider and Minster Law, you won’t be liable for any difference between the overall cost and how much we recover.</p> 
                      <p>Alternatively, you can seek free treatment via the NHS or by checking existing cover through private healthcare (remember to check the excess). Sometimes the third-party insurer may offer treatment, which we would discuss with you.</p>`
                      : 
                      `<p>We recommend speaking to a GP for advice on any issues you are experiencing. 
                       You can also look at treatment options through the NHS or private healthcare. We <b>may</b> be able to include the costs of treatment in your claims. 
                       However, this is not a certainty. Sometimes the third-party representative does offer rehab. We'll discuss any offers of rehabilitation received with you.</p>`,
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: `We cannot proceed without your consent.`,
        consentDescription: `I agree to be contacted by the rehabilitation team at ${this.rehabTeam}`,
        userData: { type: 'Rehab', scope: 'Rehab' }
        },
        { 
        id: 6, 
        title: 'Medical', 
        description: `<p>As part of the claims process, you'll need to attend a short medical appointment to help value your claim.</p>`,
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: `We cannot proceed without your consent.`,
        consentDescription: `I accept`,
        userData: { type: 'Medical', scope: 'Medical' }
        },
        { 
        id: 7, 
        title: 'Call close', 
        description: `<p>Thank you for registering your claim information with us.</p> 
                        <h5>Important information</h5>
                        <ul>
                          <li>Other solicitors or the third party may try and contact you, please inform them to contact Minster Law.</li>
                          <li>We collect and process data in line with our obligations under the Data Protection Act. A copy of our privacy policy is on our website and in our welcome pack.</li>
                          <li>It's common to have out-of-pocket expenses after an accident, so remember to keep receipts and take photos of damaged items. </li>
                          <li>Your medical appointment will be confirmed following an admission of liability from the third-party insurer.</li>
                        </ul>                    
                        `,
        checked: false,
        completed: false,
        visible: false,
        agreementAccepted: false,
        declineDescription: ``,
        consentDescription: ``,
        userData: { type: 'Call Close' }
        }
    ];
  }

  currentSectionIndex = 0;
  isSubmitting = false;
  showAlert = false;
  alertMessage = '';

  get currentSection(): SectionData {
    return this.sections[this.currentSectionIndex];
  }

  onCheckboxChange(section: SectionData, event: Event): void {
    const target = event.target as HTMLInputElement;
    const isChecked = target.checked;
    
    // Update the section
    const sectionIndex = this.sections.findIndex(s => s.id === section.id);
    if (sectionIndex !== -1) {
      this.sections[sectionIndex] = {
        ...this.sections[sectionIndex],
        checked: isChecked,
        agreementAccepted: isChecked
      };
    }
  } 

  isCurrentSectionValid(): boolean {
    return this.currentSection.checked;
  }

  confirmSection(): void {
    if (this.isCurrentSectionValid()) {
      this.sections[this.currentSectionIndex].completed = true;
      this.sections[this.currentSectionIndex].visible = false;
      this.showAlert = false;

      if (this.currentSectionIndex < this.sections.length - 1) {
        this.currentSectionIndex++;
        this.sections[this.currentSectionIndex].visible = true;
      }
    } else {
      this.showAlertMessage('You must consent to proceed to the next section.');
    }
  }

  declineSection(section: SectionData): void {
    this.showAlertMessage(section.declineDescription);
  }

  private showAlertMessage(message: string): void {
    this.alertMessage = message;
    this.showAlert = true;
    
    setTimeout(() => {
      this.showAlert = false;
    }, 5000);
  }

  allSectionsCompleted(): boolean {
    return this.sections.every(section => section.completed);
  }

  isFinalSection(): boolean {
    return this.currentSectionIndex === this.sections.length - 1;
  }

   private prepareScriptingAgreedModel(): any { 
    return {
      funding: this.getSectionAgreement(2), 
      statementOfTruth: this.getSectionAgreement(1),  
      rehab: this.getSectionAgreement(5),  
      medical: this.getSectionAgreement(6), 
      askCue: this.getSectionAgreement(4),  
      callClose: true,  
      uninsuredGuidance: false,  
      foreignVehicleGuidance: false, 
      untracedScripting: false,  
      treatmentAdvice: false, 
      happyToProceed: this.getSectionAgreement(3), 
      consentToDataSharing: this.getSectionAgreement(4), 
      updatedBy: this.stateService.customer?.emailAddress || this.stateService.claim?.updatedBy || 'digitalonboarding.system@minsterlaw.co.uk' 
    };
  }

    private getSectionAgreement(sectionId: number): boolean {
    const section = this.sections.find(s => s.id === sectionId);
    return section ? section.agreementAccepted : false;
  }
 

  finalSubmit(): void { 
    this.sections[this.currentSectionIndex].completed = true;
    this.isSubmitting = true;

    const scriptingAgreedModel = this.prepareScriptingAgreedModel(); 

    const claimReference = this.stateService.claim?.claimReference;

    if (claimReference) {      
        this.claimsService.updateScriptingAgreedModel(claimReference, scriptingAgreedModel).subscribe({
          next: (response) => { 
            this.isSubmitting = false;
            this.router.navigate(['whats-next']);
          },
          error: (error) => {
            console.error('Error calling save claim summary:', error);
            this.isSubmitting = false;
            this.showAlertMessage('Failed to submit data. Please try again.');
          }
        });
      } else {
        console.error('Claim reference is undefined');
        this.isSubmitting = false;
        this.showAlertMessage('Claim reference is missing. Please try again.');
      }
  }

 
  goToPreviousSection(): void {
    if (this.currentSectionIndex > 0) {
      this.sections[this.currentSectionIndex].visible = false;
      this.currentSectionIndex--;
      this.sections[this.currentSectionIndex].visible = true;
      this.showAlert = false;
    }
  }
 
  viewCapturedData(): void {
    const data = this.prepareSubmissionData();
    alert('Check console for captured data');
  }
 
  private prepareSubmissionData(): any {
    const submissionData = { 
      sections: this.sections.map(section => ({
        sectionId: section.id,
        sectionTitle: section.title,
        agreementAccepted: section.agreementAccepted, 
        userData: section.userData
      })),
      summary: {
        totalSections: this.sections.length,
        completedSections: this.sections.filter(s => s.completed).length,
        allAccepted: this.sections.every(s => s.agreementAccepted)
      }
    };

    console.log('Final submission data:', submissionData);
    return submissionData;
  }

}
